import React, {useCallback, useState} from 'react';
import {
    InputFieldType,
    InputGroup,
    SettingContainer,
} from 'shared/components/Settings/SettingsPanel';
import {parseHtmlString} from 'shared/helpers/HTMLParser';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import styled from 'styled-components';

export const LabelValue = ({field}: {field: InputFieldType}) => {
    const [show, setShow] = useState<boolean>(
        field.enableCopy ? undefined : false
    );
    const [content, setContent] = useState('Click to copy');

    const copyOnClickHandler = useCallback(
        (value: string | number | boolean) => () => {
            void navigator.clipboard.writeText(String(value));
            setContent('Copied!');
            setShow(true);
            setTimeout(() => {
                setShow(undefined);
                setContent('Click to copy');
            }, 300);
        },
        []
    );

    const renderTooltip = useCallback(
        (props: React.ComponentProps<typeof Tooltip>) => {
            return (
                <ModifiedTooltip
                    {...props}
                    style={{
                        ...props.style,
                        minWidth: '100px',
                    }}>
                    {content}
                </ModifiedTooltip>
            );
        },
        [content]
    );

    return (
        <InputGroup>
            <SettingContainer>
                <label>{field.label}</label>
            </SettingContainer>
            <SettingContainer>
                <OverlayTrigger
                    placement="top"
                    show={show}
                    trigger={['hover', 'focus']}
                    overlay={renderTooltip}>
                    <label
                        onClick={
                            field.enableCopy
                                ? copyOnClickHandler(field?.copyValue || '')
                                : undefined
                        }
                        style={
                            field.enableCopy
                                ? {
                                      cursor: 'pointer',
                                  }
                                : {}
                        }>
                        {typeof field.value === 'string'
                            ? parseHtmlString(field.value)
                            : field.value}
                    </label>
                </OverlayTrigger>
            </SettingContainer>
        </InputGroup>
    );
};

const ModifiedTooltip = styled(Tooltip)`
    min-width: 100px;

    > div.tooltip-inner {
        text-align: center;
    }
`;
